// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"1a6a3409","416":"0f84358a","538":"9550dc4c","545":"363a01e3","566":"dc24416a","614":"084c75c7","676":"3380c52c"}[chunkId] + ".chunk.js";
};